import {
  NEUTRO_OVERLINE_COLOR,
  NEUTRO_PARAGRAPHS_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_HOVER,
  PRIMARY_BUTTON_COLOR_PRESSED,
  SECONDARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR_HOVER,
} from "./constants";
import {
  getSubcategoryIconDevelopmentEnv,
  getSubcategoryIconProdEnv,
  getSubcategoryTranslateKeyDev,
  getSubcategoryTranslateKeyProd,
} from "./subcategories";
import confirmation_number from "@/assets/images/categories/confirmation_number.svg";
import cultura from "@/assets/images/categories/cultura.svg";
import design_services from "@/assets/images/categories/design_services.svg";
import downhill_skiing from "@/assets/images/categories/downhill_skiing.svg";
import extension from "@/assets/images/categories/extension.svg";
import flor_De_loto from "@/assets/images/categories/flor_de_loto.svg";
import forest from "@/assets/images/categories/forest.svg";
import fotografia from "@/assets/images/categories/fotografia.svg";
import Grape from "@/assets/images/categories/Grape.svg";
import hiking from "@/assets/images/categories/hiking.svg";
import paragliding from "@/assets/images/categories/paragliding.svg";
import restaurant from "@/assets/images/categories/restaurant.svg";
import sports_football from "@/assets/images/categories/sports_football.svg";
import surfing from "@/assets/images/categories/surfing.svg";
import bike from "@/assets/images/mobilityTags/bike.svg";
import bus from "@/assets/images/mobilityTags/bus.svg";
import car from "@/assets/images/mobilityTags/car.svg";
import hotel from "@/assets/images/mobilityTags/hotel.svg";
import train from "@/assets/images/mobilityTags/train.svg";
import walk from "@/assets/images/mobilityTags/walk.svg";
import { ActivityImageDto } from "@/model";

export const getHoverColor = (color: string): string => {
  switch (color) {
    case PRIMARY_BUTTON_COLOR:
      return PRIMARY_BUTTON_COLOR_HOVER;
    case SECONDARY_BUTTON_COLOR:
      return SECONDARY_BUTTON_COLOR_HOVER;
    case NEUTRO_TITLES_COLOR:
      return NEUTRO_PARAGRAPHS_COLOR;
    default:
      return color;
  }
};

export const getPressedColor = (color: string): string => {
  switch (color) {
    case PRIMARY_BUTTON_COLOR:
      return PRIMARY_BUTTON_COLOR_PRESSED;
    case SECONDARY_BUTTON_COLOR:
      return SECONDARY_BUTTON_COLOR;
    case NEUTRO_TITLES_COLOR:
      return NEUTRO_OVERLINE_COLOR;
    default:
      return color;
  }
};

export const parseSecondsToTimer = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const secondsLeft = seconds % 60;
  return `${minutes}:${secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft}`;
};

export const renderCategoryIcon = (id: number): string => {
  const imInProd =
    process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT === "false";
  if (imInProd) {
    switch (id) {
      case 41:
        return surfing.src;
      case 42:
        return paragliding.src;
      case 43:
        return hiking.src;
      case 4:
        return flor_De_loto.src;
      case 2:
        return cultura.src;
      case 5:
        return sports_football.src;
      case 9:
        return confirmation_number.src;
      case 7:
        return fotografia.src;
      case 44:
        return Grape.src;
      case 3:
        return restaurant.src;
      case 10:
        return design_services.src;
      case 47:
        return extension.src;
      case 45:
        return downhill_skiing.src;
      case 46:
        return forest.src;
      default:
        return confirmation_number.src;
    }
  } else {
    switch (id) {
      case 41:
        return surfing.src;
      case 42:
        return hiking.src;
      case 43:
        return paragliding.src;
      case 4:
        return flor_De_loto.src;
      case 2:
        return cultura.src;
      case 5:
        return sports_football.src;
      case 9:
        return confirmation_number.src;
      case 7:
        return fotografia.src;
      case 44:
        return Grape.src;
      case 3:
        return restaurant.src;
      case 10:
        return design_services.src;
      case 45:
        return extension.src;
      case 46:
        return downhill_skiing.src;
      case 47:
        return forest.src;
      default:
        return confirmation_number.src;
    }
  }
};

export const renderMobilityTagIcon = (id: number): string => {
  switch (id) {
    case 1:
      return train.src;
    case 2:
      return car.src;
    case 4:
      return walk.src;
    case 3:
      return bus.src;
    case 5:
      return bike.src;
    case 6:
      return hotel.src;
    default:
      return "";
  }
};

export const getMinuteDifference = (start: string, end: string): string => {
  const startDateArray = start.split(":");
  const endDateArray = end.split(":");
  const startDateToMinutes =
    parseInt(startDateArray[0]) * 60 + parseInt(startDateArray[1]);
  let endDateToMinutes =
    parseInt(endDateArray[0]) * 60 + parseInt(endDateArray[1]);
  const ONE_DAY_IN_MINUTES = 1440;
  if (startDateToMinutes > endDateToMinutes) {
    endDateToMinutes = endDateToMinutes + ONE_DAY_IN_MINUTES;
  }
  const difference = endDateToMinutes - startDateToMinutes;
  if (difference >= 60) {
    const hours = Math.floor(difference / 60);
    const minutes = difference % 60;
    if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}m`;
    }
  }
  return `${difference}m`;
};

export const getStringDateToShow = (date: string): string => {
  const dateArray = date.split("-");
  return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
};

export const getCoverImage = (images: ActivityImageDto[]): string => {
  if (images?.find((image) => image.type !== "BANNER")) {
    return images.find((image) => image.type !== "BANNER")?.link ?? "";
  } else {
    return images[0].link;
  }
};

export const renderSubCategoryMarker = (
  categoryId: number,
  id: number,
): { url: string; scaledSize: google.maps.Size } => {
  const commonIconSize = new window.google.maps.Size(30, 30);

  const imInProd =
    process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT === "false";
  if (imInProd) {
    return {
      url: getSubcategoryIconProdEnv(categoryId, id),
      scaledSize: commonIconSize,
    };
  } else {
    return {
      url: getSubcategoryIconDevelopmentEnv(categoryId, id),
      scaledSize: commonIconSize,
    };
  }
};

export const renderSubCategoryIcon = (
  categoryId: number,
  id: number,
): string => {
  const imInProd =
    process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT === "false";
  if (imInProd) {
    return getSubcategoryIconProdEnv(categoryId, id);
  } else {
    return getSubcategoryIconDevelopmentEnv(categoryId, id);
  }
};

export const getSubCategoryTranslationKey = (id: number): string => {
  const imInProd =
    process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT === "false";
  if (imInProd) {
    return getSubcategoryTranslateKeyProd(id);
  } else {
    return getSubcategoryTranslateKeyDev(id);
  }
};
